import React from 'react'
import { Color23, Colors23 } from '@grammarly/badger-ui'

interface CtaArrowProps extends React.SVGProps<SVGSVGElement> {
  color?: Color23
}

export const CtaArrow: React.FC<CtaArrowProps> = ({ color, ...restProps }) => {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill={color ? Colors23[color] : 'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path d="M5.056 1.748L6.144 0.691999L10.304 4.836V4.948L6.144 9.108L5.056 8.036L7.44 5.652H0.304V4.132H7.424L5.056 1.748Z" />
    </svg>
  )
}
